import { inject, Injectable } from "@angular/core";

import { PageCollection, PageIterator } from "@microsoft/microsoft-graph-client";
import { Group, User } from "@microsoft/microsoft-graph-types"
import { from, map, Observable } from "rxjs";

import { UserNotFoundError } from "@app/core/errors";
import { MicrosoftGraphService } from "@app/core/services/microsoft/graph/microsoft-graph.service";

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private client = inject(MicrosoftGraphService).client;

  getUser(): Observable<User> {
    return from(this.client.api(`/me`).get());
  };

  getUserByEmail(email: string): Observable<User> {
    return from(this.client.api(`/users`)
      .header('ConsistencyLevel', 'eventual')
      .query({ $filter: `mail eq '${email}' or userPrincipalName eq '${email}'` })
      .top(1)
      .get()
    ).pipe(
      map((response: PageCollection) => {
        if (response.value.length > 0) {
          return response.value[0];
        } else {
          throw new UserNotFoundError(email);
        }
      })
    );
  };

  private async getAllMemberOf(): Promise<Group[]> {
    const teams: Group[] = [];

    const response: PageCollection = await this.client.api(`/me/memberOf`)
      .query({
        $top: 999,
        $count: 'true',
        $filter: `resourceProvisioningOptions/any(c:c eq 'Team')`,
        $select: 'id,displayName,mail',
      })
      .header('ConsistencyLevel', 'eventual')
      .get();

    const pageIterator = new PageIterator(this.client, response, (group: Group) => {
      teams.push(group);
      return true;
    });

    await pageIterator.iterate();

    return teams;
  }

  getUserTeams(): Observable<Group[]> {
    return from(this.getAllMemberOf());
  }
}
